import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Toasts from '../Toasts'
import { useIdleTimer } from 'react-idle-timer'
import { store } from '../../../Store'
import MessageBar from '../MessageBar'
import useClasses from '../../../helpers/useClasses';

const styles = theme => ({
  root: {
    display: 'inline-block',
    borderRadius: '50%',
    flexGrow: 0,
    flexShrink: 0
  },
  sm: {
    height: theme.spacing(1),
    width: theme.spacing(1)
  },
  md: {
    height: theme.spacing(2),
    width: theme.spacing(2)
  },
  lg: {
    height: theme.spacing(3),
    width: theme.spacing(3)
  },
  neutral: {
    backgroundColor: theme.palette.neutral
  },
  primary: {
    backgroundColor: theme.palette.primary.main
  },
  info: {
    backgroundColor: theme.palette.info.main
  },
  warning: {
    backgroundColor: theme.palette.warning.main
  },
  danger: {
    backgroundColor: theme.palette.error.main
  },
  success: {
    backgroundColor: theme.palette.success.main
  }
});

const Maintenance = props => {
  const { className, size, color, maintenance, ...rest } = props;
  const [remaining, setRemaining] = useState(0)
  
  const classes = useClasses(styles);

  let maintenancebar = (
    <div></div>
  )
  if(maintenance){
    maintenancebar = (
      <MessageBar
      severity={"warning"}
      title={"DataMerch is currently undergoing maintenance."}
    />
    )
  }

  return (
    <React.Fragment>
      {maintenancebar}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    maintenance: state.appSettings.maintenance
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Maintenance)
